const mapJson = {
  cardResumenTerrestre: [
    {
      label: "customer",
      infoTool: true,
      arrayInfoTool: [
        {
          label: "country",
          key: "CustomerCountry",
        },
        {
          label: "state",
          key: "CustomerPostCode",
        },
        {
          label: "city",
          key: "CustomerCity",
        },
        {
          label: "address",
          key: "CustomerAddress",
        },
        {
          label: "phone",
          key: "CustomerTelephone",
        },
      ],
      data: [
        {
          value: "",
          key: "CustomerName",
          label: "name",

          bold: false,
          info: true,
        },
        {
          value: "",

          key: "CustomerCountry",
          label: "country",
          bold: false,
        },

        {
          value: "",
          key: "",
          label: "shipper",
          infoTool: true,
          arrayInfoTool: [
            {
              label: "country",
              key: "ShipperCountry",
            },
            {
              label: "state",
              key: "ShipperPostCode",
            },
            {
              label: "city",
              key: "ShipperCity",
            },
            {
              label: "address",
              key: "ShipperAddress",
            },
            {
              label: "phone",
              key: "ShipperTelephone",
            },
          ],
          bold: true,
          info: false,
        },
        {
          value: "",
          key: "ShipperName",
          label: "name",
          bold: false,
        },
        {
          value: "",
          key: "ShipperCountry",
          label: "country",
          bold: false,
        },
        {
          value: "",
          key: "",
          primary: true,
          label: "consignee",
          bold: true,
          info: false,
          infoTool: true,
          arrayInfoTool: [
            {
              label: "country",
              key: "ConsigneeCountry",
            },
            {
              label: "state",
              key: "ConsigneePostCode",
            },
            {
              label: "city",
              key: "ConsigneeCity",
            },
            {
              label: "address",
              key: "ConsigneeAddress",
            },
            {
              label: "phone",
              key: "ConsigneeTelephone",
            },
          ],
        },
        {
          value: "",
          key: "ConsigneeName",
          label: "name",
          bold: false,
          info: false,
          labelTol: "texto de prueba",
        },
        {
          value: "",
          key: "ConsigneeCountry",
          label: "country",
          bold: false,
        },
      ],
    },
    {
      label: "route",
      data: [
        {
          value: "",
          key: "POL",
          label: "origin",
          infoTool: true,
          oneRowInfoTool: true,
          arrayInfoTool: [
            {
              label: "name",
              key: "POLName",
            },
          ],
          bold: false,
          info: false,
        },
        {
          value: "",
          key: "POD",
          label: "destination",
          infoTool: true,
          oneRowInfoTool: true,
          arrayInfoTool: [
            {
              label: "name",
              key: "PODName",
            },
          ],
          bold: false,
          info: false,
        },
        // {
        //    value: '',
        //    key: 'POL',
        //    label: 'origin',
        //    bold: false
        // },
        // {
        //    value: '',
        //    key: 'POD',
        //    label: 'destination',
        //    bold: false
        // },
        {
          value: "",
          key: "ETD",
          label: "etd",
          bold: false,
        },
        {
          value: "",
          key: "ETA",
          label: "eta",
          bold: false,
        },
        {
          value: "",
          key: "NewETD",
          label: "new_etd",
          bold: false,
          table: true,
          columns: [
            { label: "", key: "Serial", minWidth: 40, maxWidth: 40 },
            {
              label: "New ETD",
              key: "EventDate",
              minWidth: 100,
              maxWidth: 100,
            },
            {
              label: "Update date",
              key: "CreateDate",
              minWidth: 100,
              maxWidth: 100,
            },
          ],
          data: [],
          EventId: 2,
        },
        {
          value: "",
          key: "NewETA",
          label: "new_eta",
          bold: false,
          table: true,
          columns: [
            { label: "", key: "Serial", minWidth: 40, maxWidth: 40 },
            {
              label: "New ETA",
              key: "EventDate",
              minWidth: 100,
              maxWidth: 100,
            },
            {
              label: "Update date",
              key: "CreateDate",
              minWidth: 100,
              maxWidth: 100,
            },
          ],
          data: [],
          EventId: 1,
        },
        {
          value: "",
          key: "ATD",
          label: "ATD",
          bold: false,
        },
        {
          value: "",
          key: "ATA",
          label: "ATA",
          bold: false,
        },
      ],
    },
    {
      label: "General",
      data: [
        {
          value: "",
          key: "CustomertRef",
          label: "customer_references",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "RoutingOrder",
          label: "routing_order_ro",
          primary: false,
          otro: false,
        },
        // {
        //    value: '',
        //    key: 'Branch',
        //    label: 'branch',
        //    bold: false
        // },
        {
          value: "",
          key: "Service",
          label: "service",
          bold: false,
        },
        {
          value: "",
          key: "ShipmentType",
          label: "shipment_type",
          bold: false,
        },
        {
          value: "",
          key: "HBL_HAWB",
          label: "hbl_hawb",
          bold: false,
        },
        {
          value: "",
          key: "Vessel",
          label: "vessel",
          bold: false,
        },
        {
          value: "",
          key: "Voyage_FlightNumber",
          label: "flight_voyage",
          bold: false,
        },
        {
          value: "",
          key: "Carrier",
          label: "carrier",
          bold: false,
        },
        {
          value: "",
          key: "Incoterm",
          label: "incoterm",
          primary: false,
          otro: true,
        },
        {
          value: "",
          key: "DescriptionGoods",
          label: "goods_description",
          primary: false,
          otro: true,
        },
        {
          value: "",
          key: "CO2",
          label: "CO2",
          primary: false,
          otro: true,
        },
      ],
    },
    {
      label: "cargo",
      data: [
        {
          value: "",
          key: "UOMTotalWeight",
          label: "weight",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "UOMTotalVolume",
          label: "volume",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "ChargeableWeight",
          label: "chargeable_weight",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "GoodsValueCurrency",
          label: "goods_value",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "UOMInsurance",
          label: "insurance",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "Package",
          label: "package",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "PackageType",
          label: "package_type",
          primary: false,
          otro: false,
        },
      ],
    },
  ],
  cardResumenTerrestreFCL: [
    {
      label: "customer",
      infoTool: true,
      arrayInfoTool: [
        {
          label: "country",
          key: "CustomerCountry",
        },
        {
          label: "state",
          key: "CustomerPostCode",
        },
        {
          label: "city",
          key: "CustomerCity",
        },
        {
          label: "address",
          key: "CustomerAddress",
        },
        {
          label: "phone",
          key: "CustomerTelephone",
        },
      ],
      data: [
        {
          value: "",
          key: "CustomerName",
          label: "name",

          bold: false,
          info: true,
        },
        {
          value: "",

          key: "CustomerCountry",
          label: "country",
          bold: false,
        },
        {
          value: "",
          key: "",
          label: "shipper",
          infoTool: true,
          arrayInfoTool: [
            {
              label: "country",
              key: "ShipperCountry",
            },
            {
              label: "state",
              key: "ShipperPostCode",
            },
            {
              label: "city",
              key: "ShipperCity",
            },
            {
              label: "address",
              key: "ShipperAddress",
            },
            {
              label: "phone",
              key: "ShipperTelephone",
            },
          ],
          bold: true,
          info: false,
        },
        {
          value: "",
          key: "ShipperName",
          label: "name",
          bold: false,
        },
        {
          value: "",
          key: "ShipperCountry",
          label: "country",
          bold: false,
        },
        {
          value: "",
          key: "",
          primary: true,
          label: "consignee",
          bold: true,
          info: false,
          infoTool: true,
          arrayInfoTool: [
            {
              label: "country",
              key: "ConsigneeCountry",
            },
            {
              label: "state",
              key: "ConsigneePostCode",
            },
            {
              label: "city",
              key: "ConsigneeCity",
            },
            {
              label: "address",
              key: "ConsigneeAddress",
            },
            {
              label: "phone",
              key: "ConsigneeTelephone",
            },
          ],
        },
        {
          value: "",
          key: "ConsigneeName",
          label: "name",
          bold: false,
          info: false,
          labelTol: "texto de prueba",
        },
        {
          value: "",
          key: "ConsigneeCountry",
          label: "country",
          bold: false,
        },
      ],
    },
    {
      label: "route",
      data: [
        {
          value: "",
          key: "POL",
          label: "origin",
          infoTool: true,
          oneRowInfoTool: true,
          arrayInfoTool: [
            {
              label: "name",
              key: "POLName",
            },
          ],
          bold: false,
          info: false,
        },
        {
          value: "",
          key: "POD",
          label: "destination",
          infoTool: true,
          oneRowInfoTool: true,
          arrayInfoTool: [
            {
              label: "name",
              key: "PODName",
            },
          ],
          bold: false,
          info: false,
        },
        // {
        //    value: '',
        //    key: 'POL',
        //    label: 'origin',
        //    bold: false
        // },
        // {
        //    value: '',
        //    key: 'POD',
        //    label: 'destination',
        //    bold: false
        // },
        {
          value: "",
          key: "ETD",
          label: "etd",
          bold: false,
        },
        {
          value: "",
          key: "ETA",
          label: "eta",
          bold: false,
        },
        {
          value: "",
          key: "NewETD",
          label: "new_etd",
          bold: false,
          table: true,
          columns: [
            { label: "", key: "Serial", minWidth: 40, maxWidth: 40 },
            {
              label: "New ETD",
              key: "EventDate",
              minWidth: 100,
              maxWidth: 100,
            },
            {
              label: "Update date",
              key: "CreateDate",
              minWidth: 100,
              maxWidth: 100,
            },
          ],
          data: [],
          EventId: 2,
        },
        {
          value: "",
          key: "NewETA",
          label: "new_eta",
          bold: false,
          table: true,
          columns: [
            { label: "", key: "Serial", minWidth: 40, maxWidth: 40 },
            {
              label: "New ETA",
              key: "EventDate",
              minWidth: 100,
              maxWidth: 100,
            },
            {
              label: "Update date",
              key: "CreateDate",
              minWidth: 100,
              maxWidth: 100,
            },
          ],
          data: [],
          EventId: 1,
        },
        {
          value: "",
          key: "ATD",
          label: "ATD",
          bold: false,
        },
        {
          value: "",
          key: "ATA",
          label: "ATA",
          bold: false,
        },
      ],
    },
    {
      label: "General",
      data: [
        {
          value: "",
          key: "CustomertRef",
          label: "customer_references",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "RoutingOrder",
          label: "routing_order_ro",
          primary: false,
          otro: false,
        },
        // {
        //    value: '',
        //    key: 'Branch',
        //    label: 'branch',
        //    bold: false
        // },
        {
          value: "",
          key: "Service",
          label: "service",
          bold: false,
        },
        {
          value: "",
          key: "ShipmentType",
          label: "shipment_type",
          bold: false,
        },
        {
          value: "",
          key: "HBL_HAWB",
          label: "hbl_hawb",
          bold: false,
        },
        {
          value: "",
          key: "Vessel",
          label: "vessel",
          bold: false,
        },
        {
          value: "",
          key: "Voyage_FlightNumber",
          label: "flight_voyage",
          bold: false,
        },
        {
          value: "",
          key: "Carrier",
          label: "carrier",
          bold: false,
        },
        {
          value: "",
          key: "Incoterm",
          label: "incoterm",
          primary: false,
          otro: true,
        },
        {
          value: "",
          key: "DescriptionGoods",
          label: "goods_description",
          primary: false,
          otro: true,
        },
        {
          value: "",
          key: "CO2",
          label: "CO2",
          primary: false,
          otro: true,
        },
      ],
    },
    {
      label: "cargo",
      data: [
        {
          value: "",
          key: "UOMTotalWeight",
          label: "weight",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "UOMTotalVolume",
          label: "volume",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "ChargeableWeight",
          label: "chargeable_weight",
          primary: false,
          otro: false,
        },

        {
          value: "",
          key: "TotalContainers",
          label: "total_containers",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "TotalTEUS",
          label: "teus",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "GoodsValueCurrency",
          label: "goods_value",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "UOMInsurance",
          label: "insurance",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "Package",
          label: "package",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "PackageType",
          label: "package_type",
          primary: false,
          otro: false,
        },
      ],
    },
  ],
  cardResumenAereo: [
    {
      label: "customer",
      infoTool: true,
      arrayInfoTool: [
        {
          label: "country",
          key: "CustomerCountry",
        },
        {
          label: "state",
          key: "CustomerPostCode",
        },
        {
          label: "city",
          key: "CustomerCity",
        },
        {
          label: "address",
          key: "CustomerAddress",
        },
        {
          label: "phone",
          key: "CustomerTelephone",
        },
      ],
      data: [
        {
          value: "",
          key: "CustomerName",
          label: "name",

          bold: false,
          info: true,
        },
        {
          value: "",

          key: "CustomerCountry",
          label: "country",
          bold: false,
        },

        {
          value: "",
          key: "",
          label: "shipper",
          infoTool: true,
          arrayInfoTool: [
            {
              label: "country",
              key: "ShipperCountry",
            },
            {
              label: "state",
              key: "ShipperPostCode",
            },
            {
              label: "city",
              key: "ShipperCity",
            },
            {
              label: "address",
              key: "ShipperAddress",
            },
            {
              label: "phone",
              key: "ShipperTelephone",
            },
          ],
          bold: true,
          info: false,
        },
        {
          value: "",
          key: "ShipperName",
          label: "name",
          bold: false,
        },
        {
          value: "",
          key: "ShipperCountry",
          label: "country",
          bold: false,
        },
        {
          value: "",
          key: "",
          primary: true,
          label: "consignee",
          bold: true,
          info: false,
          infoTool: true,
          arrayInfoTool: [
            {
              label: "country",
              key: "ConsigneeCountry",
            },
            {
              label: "state",
              key: "ConsigneePostCode",
            },
            {
              label: "city",
              key: "ConsigneeCity",
            },
            {
              label: "address",
              key: "ConsigneeAddress",
            },
            {
              label: "phone",
              key: "ConsigneeTelephone",
            },
          ],
        },
        {
          value: "",
          key: "ConsigneeName",
          label: "name",
          bold: false,
          info: false,
          labelTol: "texto de prueba",
        },
        {
          value: "",
          key: "ConsigneeCountry",
          label: "country",
          bold: false,
        },
      ],
    },
    {
      label: "route",
      data: [
        {
          value: "",
          key: "POL",
          label: "origin",
          infoTool: true,
          oneRowInfoTool: true,
          arrayInfoTool: [
            {
              label: "name",
              key: "POLName",
            },
          ],
          bold: false,
          info: false,
        },
        {
          value: "",
          key: "POD",
          label: "destination",
          infoTool: true,
          oneRowInfoTool: true,
          arrayInfoTool: [
            {
              label: "name",
              key: "PODName",
            },
          ],
          bold: false,
          info: false,
        },
        // {
        //    value: '',
        //    key: 'POL',
        //    label: 'origin',
        //    bold: false
        // },
        // {
        //    value: '',
        //    key: 'POD',
        //    label: 'destination',
        //    bold: false
        // },
        {
          value: "",
          key: "ETD",
          label: "etd",
          bold: false,
        },
        {
          value: "",
          key: "ETA",
          label: "eta",
          bold: false,
        },
        {
          value: "",
          key: "NewETD",
          label: "new_etd",
          bold: false,
          table: true,
          columns: [
            { label: "", key: "Serial", minWidth: 40, maxWidth: 40 },
            {
              label: "New ETD",
              key: "EventDate",
              minWidth: 100,
              maxWidth: 100,
            },
            {
              label: "Update date",
              key: "CreateDate",
              minWidth: 100,
              maxWidth: 100,
            },
          ],
          data: [],
          EventId: 2,
        },
        {
          value: "",
          key: "NewETA",
          label: "new_eta",
          bold: false,
          table: true,
          columns: [
            { label: "", key: "Serial", minWidth: 40, maxWidth: 40 },
            {
              label: "New ETA",
              key: "EventDate",
              minWidth: 100,
              maxWidth: 100,
            },
            {
              label: "Update date",
              key: "CreateDate",
              minWidth: 100,
              maxWidth: 100,
            },
          ],
          data: [],
          EventId: 1,
        },
        {
          value: "",
          key: "ATD",
          label: "ATD",
          bold: false,
        },
        {
          value: "",
          key: "ATA",
          label: "ATA",
          bold: false,
        },
      ],
    },
    {
      label: "General",
      data: [
        {
          value: "",
          key: "CustomertRef",
          label: "customer_references",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "RoutingOrder",
          label: "routing_order_ro",
          primary: false,
          otro: false,
        },

        // {
        //    value: '',
        //    key: 'Branch',
        //    label: 'branch',
        //    bold: false
        // },
        {
          value: "",
          key: "Service",
          label: "service",
          bold: false,
        },
        {
          value: "",
          key: "ShipmentType",
          label: "shipment_type",
          bold: false,
        },
        {
          value: "",
          key: "HBL_HAWB",
          label: "hbl_hawb",
          bold: false,
        },
        {
          value: "",
          key: "Vessel",
          label: "vessel",
          bold: false,
        },
        {
          value: "",
          key: "Voyage_FlightNumber",
          label: "flight_voyage",
          bold: false,
        },
        {
          value: "",
          key: "Carrier",
          label: "carrier",
          bold: false,
        },
        {
          value: "",
          key: "Incoterm",
          label: "incoterm",
          primary: false,
          otro: true,
        },
        {
          value: "",
          key: "DescriptionGoods",
          label: "goods_description",
          primary: false,
          otro: true,
        },
        {
          value: "",
          key: "CO2",
          label: "CO2",
          primary: false,
          otro: true,
        },
      ],
    },
    {
      label: "cargo",
      data: [
        {
          value: "",
          key: "UOMTotalWeight",
          label: "weight",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "UOMTotalVolume",
          label: "volume",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "ChargeableWeight",
          label: "chargeable_weight",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "GoodsValueCurrency",
          label: "goods_value",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "UOMInsurance",
          label: "insurance",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "Package",
          label: "package",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "PackageType",
          label: "package_type",
          primary: false,
          otro: false,
        },
      ],
    },
  ],
  cardResumenAereoFCL: [
    {
      label: "customer",
      infoTool: true,
      arrayInfoTool: [
        {
          label: "country",
          key: "CustomerCountry",
        },
        {
          label: "state",
          key: "CustomerPostCode",
        },
        {
          label: "city",
          key: "CustomerCity",
        },
        {
          label: "address",
          key: "CustomerAddress",
        },
        {
          label: "phone",
          key: "CustomerTelephone",
        },
      ],
      data: [
        {
          value: "",
          key: "CustomerName",
          label: "name",

          bold: false,
          info: true,
        },
        {
          value: "",

          key: "CustomerCountry",
          label: "country",
          bold: false,
        },

        {
          value: "",
          key: "",
          label: "shipper",
          infoTool: true,
          arrayInfoTool: [
            {
              label: "country",
              key: "ShipperCountry",
            },
            {
              label: "state",
              key: "ShipperPostCode",
            },
            {
              label: "city",
              key: "ShipperCity",
            },
            {
              label: "address",
              key: "ShipperAddress",
            },
            {
              label: "phone",
              key: "ShipperTelephone",
            },
          ],
          bold: true,
          info: false,
        },
        {
          value: "",
          key: "ShipperName",
          label: "name",
          bold: false,
        },
        {
          value: "",
          key: "ShipperCountry",
          label: "country",
          bold: false,
        },
        {
          value: "",
          key: "",
          primary: true,
          label: "consignee",
          bold: true,
          info: false,
          infoTool: true,
          arrayInfoTool: [
            {
              label: "country",
              key: "ConsigneeCountry",
            },
            {
              label: "state",
              key: "ConsigneePostCode",
            },
            {
              label: "city",
              key: "ConsigneeCity",
            },
            {
              label: "address",
              key: "ConsigneeAddress",
            },
            {
              label: "phone",
              key: "ConsigneeTelephone",
            },
          ],
        },
        {
          value: "",
          key: "ConsigneeName",
          label: "name",
          bold: false,
          info: false,
          labelTol: "texto de prueba",
        },
        {
          value: "",
          key: "ConsigneeCountry",
          label: "country",
          bold: false,
        },
      ],
    },
    {
      label: "route",
      data: [
        {
          value: "",
          key: "POL",
          label: "origin",
          infoTool: true,
          oneRowInfoTool: true,
          arrayInfoTool: [
            {
              label: "name",
              key: "POLName",
            },
          ],
          bold: false,
          info: false,
        },
        {
          value: "",
          key: "POD",
          label: "destination",
          infoTool: true,
          oneRowInfoTool: true,
          arrayInfoTool: [
            {
              label: "name",
              key: "PODName",
            },
          ],
          bold: false,
          info: false,
        },
        // {
        //    value: '',
        //    key: 'POL',
        //    label: 'origin',
        //    bold: false
        // },
        // {
        //    value: '',
        //    key: 'POD',
        //    label: 'destination',
        //    bold: false
        // },
        {
          value: "",
          key: "ETD",
          label: "etd",
          bold: false,
        },
        {
          value: "",
          key: "ETA",
          label: "eta",
          bold: false,
        },
        {
          value: "",
          key: "NewETD",
          label: "new_etd",
          bold: false,
          table: true,
          columns: [
            { label: "", key: "Serial", minWidth: 40, maxWidth: 40 },
            {
              label: "New ETD",
              key: "EventDate",
              minWidth: 100,
              maxWidth: 100,
            },
            {
              label: "Update date",
              key: "CreateDate",
              minWidth: 100,
              maxWidth: 100,
            },
          ],
          data: [],
          EventId: 2,
        },
        {
          value: "",
          key: "NewETA",
          label: "new_eta",
          bold: false,
          table: true,
          columns: [
            { label: "", key: "Serial", minWidth: 40, maxWidth: 40 },
            {
              label: "New ETA",
              key: "EventDate",
              minWidth: 100,
              maxWidth: 100,
            },
            {
              label: "Update date",
              key: "CreateDate",
              minWidth: 100,
              maxWidth: 100,
            },
          ],
          data: [],
          EventId: 1,
        },
        {
          value: "",
          key: "ATD",
          label: "ATD",
          bold: false,
        },
        {
          value: "",
          key: "ATA",
          label: "ATA",
          bold: false,
        },
      ],
    },
    {
      label: "General",
      data: [
        {
          value: "",
          key: "CustomertRef",
          label: "customer_references",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "RoutingOrder",
          label: "routing_order_ro",
          primary: false,
          otro: false,
        },

        // {
        //    value: '',
        //    key: 'Branch',
        //    label: 'branch',
        //    bold: false
        // },
        {
          value: "",
          key: "Service",
          label: "service",
          bold: false,
        },
        {
          value: "",
          key: "ShipmentType",
          label: "shipment_type",
          bold: false,
        },
        {
          value: "",
          key: "HBL_HAWB",
          label: "hbl_hawb",
          bold: false,
        },
        {
          value: "",
          key: "Vessel",
          label: "vessel",
          bold: false,
        },
        {
          value: "",
          key: "Voyage_FlightNumber",
          label: "flight_voyage",
          bold: false,
        },
        {
          value: "",
          key: "Carrier",
          label: "carrier",
          bold: false,
        },
        {
          value: "",
          key: "Incoterm",
          label: "incoterm",
          primary: false,
          otro: true,
        },
        {
          value: "",
          key: "DescriptionGoods",
          label: "goods_description",
          primary: false,
          otro: true,
        },
        {
          value: "",
          key: "CO2",
          label: "CO2",
          primary: false,
          otro: true,
        },
      ],
    },
    {
      label: "cargo",
      data: [
        {
          value: "",
          key: "UOMTotalWeight",
          label: "weight",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "UOMTotalVolume",
          label: "volume",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "ChargeableWeight",
          label: "chargeable_weight",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "TotalContainers",
          label: "total_containers",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "TotalTEUS",
          label: "teus",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "GoodsValueCurrency",
          label: "goods_value",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "UOMInsurance",
          label: "insurance",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "Package",
          label: "package",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "PackageType",
          label: "package_type",
          primary: false,
          otro: false,
        },
      ],
    },
  ],
  cardResumenMaritimo: [
    {
      label: "customer",
      infoTool: true,
      arrayInfoTool: [
        {
          label: "country",
          key: "CustomerCountry",
        },
        {
          label: "state",
          key: "CustomerPostCode",
        },
        {
          label: "city",
          key: "CustomerCity",
        },
        {
          label: "address",
          key: "CustomerAddress",
        },
        {
          label: "phone",
          key: "CustomerTelephone",
        },
      ],
      data: [
        {
          value: "",
          key: "CustomerName",
          label: "name",

          bold: false,
          info: true,
        },
        {
          value: "",

          key: "CustomerCountry",
          label: "country",
          bold: false,
        },

        {
          value: "",
          key: "",
          label: "shipper",
          infoTool: true,
          arrayInfoTool: [
            {
              label: "country",
              key: "ShipperCountry",
            },
            {
              label: "state",
              key: "ShipperPostCode",
            },
            {
              label: "city",
              key: "ShipperCity",
            },
            {
              label: "address",
              key: "ShipperAddress",
            },
            {
              label: "phone",
              key: "ShipperTelephone",
            },
          ],
          bold: true,
          info: false,
        },
        {
          value: "",
          key: "ShipperName",
          label: "name",
          bold: false,
        },
        {
          value: "",
          key: "ShipperCountry",
          label: "country",
          bold: false,
        },
        {
          value: "",
          key: "",
          primary: true,
          label: "consignee",
          bold: true,
          info: false,
          infoTool: true,
          arrayInfoTool: [
            {
              label: "country",
              key: "ConsigneeCountry",
            },
            {
              label: "state",
              key: "ConsigneePostCode",
            },
            {
              label: "city",
              key: "ConsigneeCity",
            },
            {
              label: "address",
              key: "ConsigneeAddress",
            },
            {
              label: "phone",
              key: "ConsigneeTelephone",
            },
          ],
        },
        {
          value: "",
          key: "ConsigneeName",
          label: "name",
          bold: false,
          info: false,
          labelTol: "texto de prueba",
        },
        {
          value: "",
          key: "ConsigneeCountry",
          label: "country",
          bold: false,
        },
      ],
    },
    {
      label: "route",
      data: [
        {
          value: "",
          key: "POL",
          label: "origin",
          infoTool: true,
          oneRowInfoTool: true,
          arrayInfoTool: [
            {
              label: "name",
              key: "POLName",
            },
          ],
          bold: false,
          info: false,
        },
        {
          value: "",
          key: "POD",
          label: "destination",
          infoTool: true,
          oneRowInfoTool: true,
          arrayInfoTool: [
            {
              label: "name",
              key: "PODName",
            },
          ],
          bold: false,
          info: false,
        },
        // {
        //    value: '',
        //    key: 'POL',
        //    label: 'origin',
        //    bold: false
        // },
        // {
        //    value: '',
        //    key: 'POD',
        //    label: 'destination',
        //    bold: false
        // },
        {
          value: "",
          key: "ETD",
          label: "etd",
          bold: false,
        },
        {
          value: "",
          key: "ETA",
          label: "eta",
          bold: false,
        },
        {
          value: "",
          key: "NewETD",
          label: "new_etd",
          bold: false,
          table: true,
          columns: [
            { label: "", key: "Serial", minWidth: 40, maxWidth: 40 },
            {
              label: "New ETD",
              key: "EventDate",
              minWidth: 100,
              maxWidth: 100,
            },
            {
              label: "Update date",
              key: "CreateDate",
              minWidth: 100,
              maxWidth: 100,
            },
          ],
          data: [],
          EventId: 2,
        },
        {
          value: "",
          key: "NewETA",
          label: "new_eta",
          bold: false,
          table: true,
          columns: [
            { label: "", key: "Serial", minWidth: 40, maxWidth: 40 },
            {
              label: "New ETA",
              key: "EventDate",
              minWidth: 100,
              maxWidth: 100,
            },
            {
              label: "Update date",
              key: "CreateDate",
              minWidth: 100,
              maxWidth: 100,
            },
          ],
          data: [],
          EventId: 1,
        },
        {
          value: "",
          key: "ATD",
          label: "ATD",
          bold: false,
        },
        {
          value: "",
          key: "ATA",
          label: "ATA",
          bold: false,
        },
      ],
    },
    {
      label: "General",
      data: [
        {
          value: "",
          key: "CustomertRef",
          label: "customer_references",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "RoutingOrder",
          label: "routing_order_ro",
          primary: false,
          otro: false,
        },

        // {
        //    value: '',
        //    key: 'Branch',
        //    label: 'branch',
        //    bold: false
        // },
        {
          value: "",
          key: "Service",
          label: "service",
          bold: false,
        },
        {
          value: "",
          key: "ShipmentType",
          label: "shipment_type",
          bold: false,
        },
        {
          value: "",
          key: "HBL_HAWB",
          label: "hbl_hawb",
          bold: false,
        },
        {
          value: "",
          key: "Vessel",
          label: "vessel",
          bold: false,
        },
        {
          value: "",
          key: "Voyage_FlightNumber",
          label: "flight_voyage",
          bold: false,
        },
        {
          value: "",
          key: "Carrier",
          label: "carrier",
          bold: false,
        },
        {
          value: "",
          key: "Incoterm",
          label: "incoterm",
          primary: false,
          otro: true,
        },
        {
          value: "",
          key: "DescriptionGoods",
          label: "goods_description",
          primary: false,
          otro: true,
        },
        {
          value: "",
          key: "CO2",
          label: "CO2",
          primary: false,
          otro: true,
        },
      ],
    },
    {
      label: "cargo",
      data: [
        {
          value: "",
          key: "UOMTotalWeight",
          label: "weight",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "UOMTotalVolume",
          label: "volume",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "ChargeableWeight",
          label: "chargeable_weight",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "GoodsValueCurrency",
          label: "goods_value",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "UOMInsurance",
          label: "insurance",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "Package",
          label: "package",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "PackageType",
          label: "package_type",
          primary: false,
          otro: false,
        },
      ],
    },
  ],
  cardResumenMaritimoFCL: [
    {
      label: "customer",
      infoTool: true,
      arrayInfoTool: [
        {
          label: "country",
          key: "CustomerCountry",
        },
        {
          label: "state",
          key: "CustomerPostCode",
        },
        {
          label: "city",
          key: "CustomerCity",
        },
        {
          label: "address",
          key: "CustomerAddress",
        },
        {
          label: "phone",
          key: "CustomerTelephone",
        },
      ],
      data: [
        {
          value: "",
          key: "CustomerName",
          label: "name",

          bold: false,
          info: true,
        },
        {
          value: "",

          key: "CustomerCountry",
          label: "country",
          bold: false,
        },

        {
          value: "",
          key: "",
          label: "shipper",
          infoTool: true,
          arrayInfoTool: [
            {
              label: "country",
              key: "ShipperCountry",
            },
            {
              label: "state",
              key: "ShipperPostCode",
            },
            {
              label: "city",
              key: "ShipperCity",
            },
            {
              label: "address",
              key: "ShipperAddress",
            },
            {
              label: "phone",
              key: "ShipperTelephone",
            },
          ],
          bold: true,
          info: false,
        },
        {
          value: "",
          key: "ShipperName",
          label: "name",
          bold: false,
        },
        {
          value: "",
          key: "ShipperCountry",
          label: "country",
          bold: false,
        },
        {
          value: "",
          key: "",
          primary: true,
          label: "consignee",
          bold: true,
          info: false,
          infoTool: true,
          arrayInfoTool: [
            {
              label: "country",
              key: "ConsigneeCountry",
            },
            {
              label: "state",
              key: "ConsigneePostCode",
            },
            {
              label: "city",
              key: "ConsigneeCity",
            },
            {
              label: "address",
              key: "ConsigneeAddress",
            },
            {
              label: "phone",
              key: "ConsigneeTelephone",
            },
          ],
        },
        {
          value: "",
          key: "ConsigneeName",
          label: "name",
          bold: false,
          info: false,
          labelTol: "texto de prueba",
        },
        {
          value: "",
          key: "ConsigneeCountry",
          label: "country",
          bold: false,
        },
      ],
    },
    {
      label: "route",
      data: [
        {
          value: "",
          key: "POL",
          label: "origin",
          infoTool: true,
          oneRowInfoTool: true,
          arrayInfoTool: [
            {
              label: "name",
              key: "POLName",
            },
          ],
          bold: false,
          info: false,
        },
        {
          value: "",
          key: "POD",
          label: "destination",
          infoTool: true,
          oneRowInfoTool: true,
          arrayInfoTool: [
            {
              label: "name",
              key: "PODName",
            },
          ],
          bold: false,
          info: false,
        },
        // {
        //    value: '',
        //    key: 'POL',
        //    label: 'origin',
        //    bold: false
        // },
        // {
        //    value: '',
        //    key: 'POD',
        //    label: 'destination',
        //    bold: false
        // },
        {
          value: "",
          key: "ETD",
          label: "etd",
          bold: false,
        },
        {
          value: "",
          key: "ETA",
          label: "eta",
          bold: false,
        },
        {
          value: "",
          key: "NewETD",
          label: "new_etd",
          bold: false,
          table: true,
          columns: [
            { label: "", key: "Serial", minWidth: 40, maxWidth: 40 },
            {
              label: "New ETD",
              key: "EventDate",
              minWidth: 100,
              maxWidth: 100,
            },
            {
              label: "Update date",
              key: "CreateDate",
              minWidth: 100,
              maxWidth: 100,
            },
          ],
          data: [],
          EventId: 2,
        },
        {
          value: "",
          key: "NewETA",
          label: "new_eta",
          bold: false,
          table: true,
          columns: [
            { label: "", key: "Serial", minWidth: 40, maxWidth: 40 },
            {
              label: "New ETA",
              key: "EventDate",
              minWidth: 100,
              maxWidth: 100,
            },
            {
              label: "Update date",
              key: "CreateDate",
              minWidth: 100,
              maxWidth: 100,
            },
          ],
          data: [],
          EventId: 1,
        },
        {
          value: "",
          key: "ATD",
          label: "ATD",
          bold: false,
        },
        {
          value: "",
          key: "ATA",
          label: "ATA",
          bold: false,
        },
      ],
    },
    {
      label: "General",
      data: [
        {
          value: "",
          key: "CustomertRef",
          label: "customer_references",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "RoutingOrder",
          label: "routing_order_ro",
          primary: false,
          otro: false,
        },

        // {
        //    value: '',
        //    key: 'Branch',
        //    label: 'branch',
        //    bold: false
        // },
        {
          value: "",
          key: "Service",
          label: "service",
          bold: false,
        },
        {
          value: "",
          key: "ShipmentType",
          label: "shipment_type",
          bold: false,
        },
        {
          value: "",
          key: "HBL_HAWB",
          label: "hbl_hawb",
          bold: false,
        },
        {
          value: "",
          key: "Vessel",
          label: "vessel",
          bold: false,
        },
        {
          value: "",
          key: "Voyage_FlightNumber",
          label: "flight_voyage",
          bold: false,
        },
        {
          value: "",
          key: "Carrier",
          label: "carrier",
          bold: false,
        },
        {
          value: "",
          key: "Incoterm",
          label: "incoterm",
          primary: false,
          otro: true,
        },
        {
          value: "",
          key: "DescriptionGoods",
          label: "goods_description",
          primary: false,
          otro: true,
        },
        {
          value: "",
          key: "CO2",
          label: "CO2",
          primary: false,
          otro: true,
        },
      ],
    },
    {
      label: "cargo",
      data: [
        {
          value: "",
          key: "UOMTotalWeight",
          label: "weight",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "UOMTotalVolume",
          label: "volume",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "ChargeableWeight",
          label: "chargeable_weight",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "TotalContainers",
          label: "total_containers",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "TotalTEUS",
          label: "teus",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "GoodsValueCurrency",
          label: "goods_value",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "UOMInsurance",
          label: "insurance",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "Package",
          label: "package",
          primary: false,
          otro: false,
        },
        {
          value: "",
          key: "PackageType",
          label: "package_type",
          primary: false,
          otro: false,
        },
      ],
    },
  ],
};

export default mapJson;
